export const handleKeywordKeyPress = (
  e: React.KeyboardEvent,
  callBack: () => any
) => {
  if (e.key === "Enter") {
    callBack();
  }
};
